if (!customElements.get('store-availability')) {
    class StoreAvailability extends HTMLElement{
        constructor(){
            super();
            this.sku = this.dataset.sku
            this.clickAndCollectContainer = this.querySelector(".click-and-collect")
            this.storeListContainer = this.querySelector(".store-availability")
            this.skeleton = this.querySelector("skeleton")
        }

        async connectedCallback(){
            const checkClickAndCollectReq = await theme.fetch.request("/pickup-info", "POST", {
                storeName: theme.store.get(),
                data: {
                    productSkus: [this.sku]
                }
            });
            
            this.skeleton?.remove()
            
            if (checkClickAndCollectReq.data.result[0][this.sku]) {
                this.handleSyncStores(this.clickAndCollectContainer, 'showDrawer-click-and-collect-drawer', "click-and-collect-drawer")
            }

            this.handleSyncStores(this.storeListContainer, 'showDrawer-store-list', "store-list-drawer")

            const fetchReqRes = await theme.fetch.request("/product-page-info", "POST", {
                "product":{
                    "storeName": theme.store.get(),
                    "productSku": [this.sku],
                    "pageType": "product"
                }
            });

            this.skeleton?.remove()

            document.dispatchEvent(new CustomEvent('generateOrderCount', {
                detail: fetchReqRes.data.ordersCount
            }));

            if (fetchReqRes.data.pickupAddress.length > 0) {
                this.handleClickAndCollectTrigger(fetchReqRes.data.pickupAddress)
            }
            
            if (fetchReqRes.data.storeDetails.length > 0) {
                this.handleStoreAvailabilityTrigger(fetchReqRes.data.storeDetails)
            }
        }

        async handleClickAndCollectTrigger(pickupAddresses){
            const stores = this.generateStores(pickupAddresses)

            document.querySelector("click-and-collect-drawer .drawer__body").innerHTML = stores.outerHTML
        }

        handleStoreAvailabilityTrigger(storeAddresses){
            const stores = this.generateStores(storeAddresses)

            document.querySelector("store-list-drawer .drawer__body").innerHTML = stores.outerHTML
        }

        generateStores(stores){
            const ul = document.createElement('ul');
            ul.className = 'store-availability-list';
            ul.setAttribute('role', 'list');

            stores.forEach(store => {
                const li = document.createElement('li');
                li.classList.add('store-availability-list__item');
                li.innerHTML = `
                <h4 class="store-title">${store.store_address.store_name}</h4>
                <address class="pickup-availability-address">
                    <p>
                    ${store.store_address.address_line_1}, ${store.store_address.address_line_2 || ''}<br/>
                    ${store.store_address.area || ''}<br/>
                    ${store.store_address.city}, ${store.store_address.state}<br/>
                    ${store.store_address.country}
                    </p>
                </address>`;
                ul.appendChild(li);
            });

            return ul
        }

        handleSyncStores(containerTarget, drawerSelector, drawerTarget){
            containerTarget.classList.remove("is-hidden")

            let clonedNode = containerTarget.querySelector(drawerTarget)

            containerTarget.querySelector(drawerTarget).remove()

            document.body.append(clonedNode)

            let Toggle =  window.themeCore.utils.Toggle;
             const drawer = Toggle({
                toggleSelector: drawerSelector
            });

            drawer.init()
        }
    }

    customElements.define('store-availability', StoreAvailability)
}